import React from 'react';
import { Input } from './input';

const PhoneInput = ({ value, onChange, ...props }) => {
  const formatPhoneNumber = (phoneNumber) => {
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '');
    
    // Apply formatting based on length
    if (cleaned.length === 0) return '';
    if (cleaned.length <= 3) return `(${cleaned}`;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };

  const handleChange = (e) => {
    const input = e.target.value;
    const formatted = formatPhoneNumber(input);
    
    // Only allow formatted phone number up to (XXX) XXX-XXXX length
    if (formatted.length <= 14) {
      onChange(formatted);
    }
  };

  return (
    <Input
      {...props}
      value={value}
      onChange={handleChange}
      placeholder="(555) 123-4567"
      maxLength={14}
    />
  );
};

export { PhoneInput };